import i18n from 'helpers/i18n';
import messages from './messages';
import useAsync from 'hooks/useAsync';
import { verifyPhone, sendSmsCode } from 'actions/sms';
import { Button, TextField, TextLink } from '@teachstonellc/component-library';
import { toastSuccess } from 'components/Toast';
import { Formik, PreventNavigation } from 'components/EnhancedForm';
import { ButtonWrapper, InputWrapper } from './Styled';
import { FormikHelpers } from 'formik';

interface SmsCodeFormProps {
  /** Callback fired when the verification code is successfully verified. */
  onSucess: () => void;
}

function SmsCodeForm({ onSucess }: SmsCodeFormProps) {
  const { run, isLoading, isError } = useAsync();
  const smsRequest = useAsync();

  function handleSubmit(values: any, formik: FormikHelpers<any>) {
    run(verifyPhone(values.code), {
      onSuccess: () => {
        formik.resetForm();
        onSucess();
      }
    });
  }

  function resendCode() {
    if (smsRequest.isLoading) {
      return;
    }

    smsRequest.run(sendSmsCode(), {
      onSuccess: () => {
        toastSuccess({ description: i18n.ft(messages.success) });
      }
    });
  }

  return (
    <Formik initialValues={{ code: '' }} onSubmit={handleSubmit}>
      {formik => (
        <form onSubmit={formik.handleSubmit} onReset={formik.handleReset}>
          <PreventNavigation />

          <InputWrapper>
            <TextField
              {...formik.getFieldProps('code')}
              label={i18n.ft(messages.enterCode)}
              pattern="[0-9]*"
              placeholder={i18n.ft(messages.verificationPlaceholder)}
              error={isError ? i18n.ft(messages.invalidCode) : undefined}
            />
          </InputWrapper>

          <ButtonWrapper>
            <Button
              type="submit"
              variant="primary"
              shape="rounded"
              disabled={isLoading}
              loading={isLoading}
            >
              {i18n.ft(messages.verify)}
            </Button>
            <TextLink as="button" type="button" onClick={resendCode}>
              {i18n.ft(messages.resendCode)}
            </TextLink>
          </ButtonWrapper>
        </form>
      )}
    </Formik>
  );
}

export default SmsCodeForm;
